import { render } from "./Hint.vue?vue&type=template&id=361b1d56"
const script = {}

import "./Hint.vue?vue&type=style&index=0&id=361b1d56&lang=css"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__